import { z } from 'zod';
import { ConversationIdSchema } from '../ids.ts';
import { PageContextSchema } from './session.ts';

const UserTextPartSchema = z.object({
  type: z.literal('text'),
  text: z.string().min(1).max(100_000),
});

export const UserMessageSchema = z.object({
  id: z.string().min(1).max(128),
  role: z.literal('user'),
  parts: z.array(UserTextPartSchema).min(1).max(16),
});
export type UserMessage = z.infer<typeof UserMessageSchema>;

export const ChatRequestSchema = z.object({
  id: ConversationIdSchema,
  message: UserMessageSchema,
  trigger: z.literal('submit-message').default('submit-message'),
  context: PageContextSchema.optional(),
  model: z.string().min(1).max(64).optional(),
  time_zone: z.string().min(1).max(64).optional(),
});
export type ChatRequest = z.input<typeof ChatRequestSchema>;
export type ChatRequestParsed = z.infer<typeof ChatRequestSchema>;

export const ChatStopResponseSchema = z.object({
  id: ConversationIdSchema,
  object: z.literal('chat.stop'),
  stopped: z.boolean(),
});
export type ChatStopResponse = z.infer<typeof ChatStopResponseSchema>;
